module.exports = __webpack_public_path__ + "static/media/teachers-guide.f00e9246.pdf";